import { useCallback, useState } from 'react';
import { EmptyStateStatus } from 'components/core/headings/EmptyState';

export type ListStatus = EmptyStateStatus;

interface ListStatusApi {
  status: ListStatus;
  /** Wrap a fetch: the status is 'loading' until it settles, then 'ready' or 'failed'. The result or error still reaches the caller. */
  track: <T>(request: Promise<T>) => Promise<T>;
}

/** Whether a list's data is still loading, loaded, or failed to load, so a screen can tell "not here yet" from "nothing to show". */
export function useListStatus(): ListStatusApi {
  const [status, setStatus] = useState<ListStatus>('loading');
  const track = useCallback(<T,>(request: Promise<T>): Promise<T> => {
    setStatus('loading');
    return request.then(
      (result) => {
        setStatus('ready');
        return result;
      },
      (error: unknown) => {
        setStatus('failed');
        throw error;
      }
    );
  }, []);
  return { status, track };
}
